<template>
  <div
    :class="
      classes(
        n(),
        n(`--${size}`),
        n(`--${variant}`),
        n(`--${color}`)
      )
    "
    :style="style"
  >
    <div :class="n('content')">
      <i
        v-if="icon"
        :class="n('icon')"
      >
        <component :is="icon" />
      </i>
      <span>{{ content }}</span>
    </div>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from 'virtual-vue';
import { props, BUILT_IN_COLOR } from './props';
import { emits } from './emits';
import { createNamespace } from '../utils/components';
import { fade } from '../utils/color';

const { name, n, classes, cssVars } = createNamespace('tag');

export default defineComponent({
  name,
  props,
  emits,
  setup(props) {
    const style = computed(() => {
      const primaryColor = props.color;
      if (BUILT_IN_COLOR.includes(primaryColor)) return {};
      return {
        [cssVars('dark-bg-color')]: primaryColor,
        [cssVars('dark-font-color')]: '#FFFFFF',
        [cssVars('dark-border-color')]: primaryColor,
        [cssVars('light-outline-bg-color')]: fade(primaryColor, 10),
        [cssVars('light-outline-font-color')]: primaryColor,
        [cssVars('light-outline-border-color')]: fade(primaryColor, 20),
      };
    });
    return {
      n,
      classes,
      style,
    };
  },
});
</script>
